import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const MobileStickyButton = () => {
  const scrollToBooking = () => {
    const bookingForm = document.querySelector('.booking-card');
    if (bookingForm) {
      bookingForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="sticky-cta-mobile">
      <Button
        variant="ctaLarge"
        size="xl"
        className="w-full"
        onClick={scrollToBooking}
      >
        <span className="flex items-center justify-center gap-2">
          Get Price Now
          <ArrowRight className="h-5 w-5" />
        </span>
      </Button>
    </div>
  );
};

export default MobileStickyButton;